import axios from 'axios';

export const VoucherApplicationsApi = {
  getBulletins: filter =>
    axios.get(`/api/public/data/buliten_of_free_place_by_filter`, { params: filter }),
  getApplications: filter =>
    axios.get(`/api/self/paging/kindergarten_voucher_queue?filter=${filter}`),
  applicationDownload: requestFormId =>
    axios.get(
      `/api/public/info/request_form_preview/${requestFormId}/zayavleniye?force=true`,
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/csv'
        }
      }
    ),
  getSignString: data =>
    axios.post(
      '/api/public/transitions/info/sign_string/kindergarten_voucher_queue',
      data
    ),
  approveVoucher: data =>
    axios.post(
      `/api/public/transitions/kindergarten_voucher_queue/receive_voucher`,
      data
    ),
  confirmInterestApi: data =>
    axios.post(
      `/api//public/transitions/kindergarten_voucher_queue/confirm_interest`,
      data
    ),
  rejectVoucher: data =>
    axios.post(`/api/public/transitions/kindergarten_voucher_queue/reject_voucher`, data),
  revokeByApplicantApi: data =>
    axios.post(`/api/public/transitions/kindergarten_voucher_queue/revoke`, data)
};
